// extracted by mini-css-extract-plugin
export default {"imageContainer":"PromoBanner_imageContainer__dbl9n","container":"PromoBanner_container__evWpw"};